// Helpful map of breakpoints and their starting-width. Used to provide
// meaningful data-sizes-xxx attributes, but must be maintained(!)
export const breakpoints = {
  xlarge: 1600,
  skyscrapers: 1350,
  dd: 1025,
  large: 1024,
  medium: 680,
  small: 0, // so the actual breakpoint is at 480, and 0 is actually base
};
